import React from 'react';

const AnchorSettings = props => {
	const { block, onChange } = props;

	let anchorStatus = false;
	let anchorText = block.label;
	if (block.content.anchor) {
		anchorStatus = block.content.anchor.status;
		anchorText = block.content.anchor.text;
	}

	return (
		<div className="form-group form-group--anchor">
			<div className="form-group__items">
				<div className="form-group__item form-group__item--full">
					<div className="form-group__input form-group__input--half">
						<label className="check__label">
							<input autoComplete="off"
								type="checkbox"
								className="check__inp"
								checked={anchorStatus}
								onChange={() => onChange(!anchorStatus, anchorText)}
							/>
							<span className="check__box"></span>
							<p className="check__text">Добавить ссылку в меню страницы</p>
						</label>
					</div>
					<div className="form-group__input form-group__input--half">
						<label className="inp">
							<input autoComplete="off"
								className="inp__field"
								type="text"
								value={anchorText}
								onChange={e => onChange(anchorStatus, e.target.value)}
							/>
							<p className="inp__label">Пункт в меню</p>
						</label>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AnchorSettings;
